// extracted by mini-css-extract-plugin
export default {"contactPerson":"contactPerson_contactPerson__rWw-r"};